import * as React from 'react';
import { MapContext } from '../Map';
import useBindEvents from '../../hooks/useBindEvents';
import { iconStr } from '../Icon';
import { IconMarkerProps, MarkerOptions } from '../Marker';
import { Events } from '../../types';

const { useContext, useEffect, useState } = React;

export interface MarkersProps {
  data?: IconMarkerProps[];
  positions?: [number, number][];
  events?: Events;
  labelToggle?: boolean; // 控制markers上的lable全部展开或者全部收起
}

function Markers(props: MarkersProps) {
  const { data, positions, events, labelToggle } = props;
  const map = useContext(MapContext);
  const [markers, setMarkers]: [any, any] = useState([]);

  useBindEvents(markers, events);

  useEffect(() => {
    if (!map) {
      return;
    }

    if (markers) {
      (map as unknown as AMap.Map).remove(markers);
    }

    let newMarkers: any[] = [];

    if (positions) {
      newMarkers = positions.map((item) => {
        const markerOptions: MarkerOptions = {} as MarkerOptions;
        markerOptions.position = item;
        return new AMap.Marker(markerOptions);
      });
    } else if (data) {
      newMarkers = data.filter((item) => item.position && Array.isArray(item.position) && item.position[0] && item.position[1]).map((item) => {
        const markerOptions: MarkerOptions = {} as MarkerOptions;
        const currentItem = {
          labelVisible: true, // 默认显示label
          ...item,
          label: item.label ? {
            ...item.label,
            offset: item.label.offset ? new AMap.Pixel(item.label.offset[0], item.label.offset[1]) : new AMap.Pixel(-9, -9),
          } : null,
        };
        const { position, type, label, labelVisible, labelCloseable,
            offset, icon, iconSize, zIndex, ...iconFontProps } = currentItem;
        if (position) {
          markerOptions.position = position;
          if (type) {
            markerOptions.content = iconStr(type, iconFontProps);
          }
          if (icon) {
            let style = 'width: 50px;height: 50px;';
            if (iconSize) {
              style = `width: ${iconSize.width}px;height: ${iconSize.height}px;`;
            }
            markerOptions.content = `<img style="${style}" src=${icon}>`;
          }
          markerOptions.offset = offset ? new AMap.Pixel(offset[0], offset[1]) : new AMap.Pixel(-9, -9);
          markerOptions.zIndex = zIndex || 100;
          markerOptions.label = labelVisible ? label : null;
          markerOptions.extData = labelVisible ? label : null;
        }
        const marker = new AMap.Marker(markerOptions);
        if (labelCloseable && label) {
          marker.on('click', function (e) {
            if (this.getLabel()){
              this.setLabel();
            } else {
              this.setLabel(label);
            }
          });
        }
        if (item.infoWindow) {
          const infoWindow = new AMap.InfoWindow({ offset: new AMap.Pixel(15, -15), anchor: 'bottom-left' });
          marker.on('mouseover', (e: any) => {
            infoWindow.setContent(item.infoWindow);
            infoWindow.open(map as any, e.target.getPosition());
          });
          marker.on('mouseout', (e: any) => {
            infoWindow.close();
          });
        }
        return marker;
      });
    }

    if (newMarkers && newMarkers.length) {
      (map as unknown as AMap.Map).add(newMarkers);
      setMarkers(newMarkers);
    }
    (map as unknown as AMap.Map).setFitView();

    return () => {
      (map as unknown as AMap.Map).remove(newMarkers);
    };

  }, [map, data, positions]);

  useEffect(() => {
    if (map && data && markers.length) {
      if (!props.labelToggle) {
        markers.forEach((markerEntitty: any) => {
          markerEntitty.setLabel();
        });
      } else {
        markers.forEach((markerEntitty: any) => {
          markerEntitty.setLabel(markerEntitty.getLabel ? markerEntitty.getLabel() : '');
        });
      }
    }
  }, [labelToggle]);

  return null;
}

export default Markers;
